import { render, staticRenderFns } from "./ModalEditDiscount.vue?vue&type=template&id=8783a534"
import script from "./ModalEditDiscount.vue?vue&type=script&lang=js"
export * from "./ModalEditDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports